export const DeliveryWarehouseMap = {
  33: "京东自营&一号店发货仓",
  35: "山姆分销发货仓",
  36: "中通简阳仓",
  37: "中通简阳次品仓",
};

export const OfflineDeliveryWarehouseOptions = ["36", "37"].map((value) => ({
  value,
  label: DeliveryWarehouseMap[value],
}));

export function getDeliveryWarehouseName(warehouseCode) {
  return DeliveryWarehouseMap[warehouseCode] || "-";
}
